import React, { useContext } from 'react'

import StoreContext from '~/context/StoreContext'
import LineItem from './LineItem'

import IcClose from '../../images/ic-cart-close.svg'

import {
  Modal,
  Drawer,
  Backdrop,
  Header,
  HeaderTitle,
  CloseButton,
  CloseIcon,
  LineItemsContainer,
  CheckoutButton,
  CartFooter,
  SubTotalContainer,
  Divider,
} from './styles'

const Cart = () => {
  const {
    store: { checkout, cart },
    closeCart,
  } = useContext(StoreContext)

  const handleCheckout = () => {
    window.open(checkout.webUrl)
  }

  const lineItems = checkout.lineItems.map(lineItem => <LineItem key={lineItem.id.toString()} line_item={lineItem} />)

  return (
    <Modal className="cart-container" open={cart.open}>
      <Backdrop open={cart.open} onClick={closeCart} />
      <Drawer open={cart.open}>
        <Header>
          <HeaderTitle>SHOPPING CART</HeaderTitle>
          <CloseButton onClick={closeCart}>
            <IcClose alt="close cart icon" />
          </CloseButton>
        </Header>
        <Divider />
        <LineItemsContainer>{lineItems}</LineItemsContainer>
        <Divider />
        <CartFooter>
          <SubTotalContainer>
            <h2>Subtotal</h2>
            <p>$ {checkout.subtotalPrice}</p>
          </SubTotalContainer>
          <CheckoutButton onClick={handleCheckout} disabled={checkout.lineItems.length === 0}>
            Check out
          </CheckoutButton>
        </CartFooter>
      </Drawer>
    </Modal>
  )
}

export default Cart
